import React, { useState } from "react";
import { getTheme } from "../App";

export const ALL_NAV_ITEMS = [
  { icon: "🏠", label: "Übersicht",       v: "dashboard" },
  { icon: "👥", label: "Mitglieder",      v: "list" },
  { icon: "🏡", label: "Gärten",          v: "gaerten" },
  { icon: "💶", label: "Finanzen",        v: "finanzen" },
  { icon: "💧", label: "Ablesungen",      v: "ablesungen" },
  { icon: "📅", label: "Kalender",        v: "kalender" },
  { icon: "🎉", label: "Feste",           v: "feste" },
  { icon: "🛒", label: "Kasse",           v: "kasse" },
  { icon: "📝", label: "Datenaufnahme",   v: "datenaufnahme" },
  { icon: "🧾", label: "Jahresrechnungen",v: "jahresrechnung" },
  { icon: "📦", label: "Archiv",          v: "archiv" },
  { icon: "🗂️", label: "Kontoauszüge",   v: "kontoauszuege" },
  { icon: "📊", label: "Bilanzen",        v: "bilanzen" },
  { icon: "👔", label: "Vorstand",        v: "vorstand" },
  { icon: "🏛️", label: "Mitgliedervers.",v: "mitgliederversammlung" },
  { icon: "💬", label: "Nachrichten",     v: "nachrichten" },
  { icon: "📋", label: "Login-Protokoll", v: "portallog" },
];

const NAV_BAR_KEY = "gv_mobile_navbar";
const NAV_BAR_DEFAULT = ["dashboard", "list", "gaerten", "finanzen", "ablesungen"];
const NAV_BAR_MAX = 5;

export function getNavBarItems() {
  try {
    const saved = JSON.parse(localStorage.getItem(NAV_BAR_KEY));
    if (Array.isArray(saved) && saved.length > 0) return saved;
  } catch(e) {}
  return NAV_BAR_DEFAULT;
}

export function NavBarEditor({ onClose }) {
  const [selected, setSelected] = useState(() => getNavBarItems());

  function toggle(v) {
    setSelected(prev => {
      if (prev.includes(v)) return prev.filter(x => x !== v);
      if (prev.length >= NAV_BAR_MAX) return prev; // max 5
      return [...prev, v];
    });
  }

  function save() {
    localStorage.setItem(NAV_BAR_KEY, JSON.stringify(selected));
    onClose();
  }

  function reset() {
    setSelected([...NAV_BAR_DEFAULT]);
  }

  const bg = getTheme() === "dark" ? "#1a1a1a" : "#fff";
  const textColor = getTheme() === "dark" ? "#fff" : "#1C2833";
  const mutedColor = getTheme() === "dark" ? "rgba(255,255,255,0.5)" : "#666";
  const leafColor = "#2D5A27";

  return (
    <>
      {/* Backdrop */}
      <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1100 }} />
      {/* Sheet */}
      <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: bg, borderRadius: "18px 18px 0 0", zIndex: 1101, boxShadow: "0 -8px 40px rgba(0,0,0,0.3)", maxHeight: "80vh", display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <div style={{ padding: "16px 20px 12px", borderBottom: `1px solid ${getTheme() === "dark" ? "rgba(255,255,255,0.1)" : "#eee"}` }}>
          <div style={{ width: 36, height: 4, background: getTheme() === "dark" ? "rgba(255,255,255,0.2)" : "#ddd", borderRadius: 2, margin: "0 auto 14px" }} />
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div>
              <div style={{ fontWeight: 700, fontSize: 16, color: textColor }}>Navigationsleiste anpassen</div>
              <div style={{ fontSize: 12, color: mutedColor, marginTop: 2 }}>
                {selected.length}/{NAV_BAR_MAX} ausgewählt
                {selected.length >= NAV_BAR_MAX && <span style={{ color: "#E74C3C", marginLeft: 6 }}>· Maximum erreicht</span>}
              </div>
            </div>
            <button onClick={reset} style={{ background: "none", border: `1px solid ${mutedColor}`, color: mutedColor, borderRadius: 8, padding: "5px 10px", fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>
              Zurücksetzen
            </button>
          </div>
        </div>

        {/* Vorschau der aktuellen Bar */}
        <div style={{ padding: "10px 20px", background: leafColor, display: "flex", justifyContent: "space-around" }}>
          {selected.map(v => {
            const item = ALL_NAV_ITEMS.find(x => x.v === v);
            if (!item) return null;
            return (
              <div key={v} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                <span style={{ fontSize: 18 }}>{item.icon}</span>
                <span style={{ fontSize: 9, color: "#fff", fontWeight: 600 }}>{item.label}</span>
              </div>
            );
          })}
          {/* Mehr-Platzhalter */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
            <span style={{ fontSize: 18 }}>☰</span>
            <span style={{ fontSize: 9, color: "rgba(255,255,255,0.6)", fontWeight: 600 }}>Mehr</span>
          </div>
        </div>

        {/* Liste aller Seiten */}
        <div style={{ overflowY: "auto", flex: 1, padding: "8px 0 20px" }}>
          {ALL_NAV_ITEMS.map(item => {
            const active = selected.includes(item.v);
            const disabled = !active && selected.length >= NAV_BAR_MAX;
            return (
              <button key={item.v} onClick={() => !disabled && toggle(item.v)}
                style={{ display: "flex", alignItems: "center", gap: 14, width: "100%", padding: "13px 20px", background: "none", border: "none", cursor: disabled ? "not-allowed" : "pointer", fontFamily: "inherit", opacity: disabled ? 0.35 : 1 }}>
                <span style={{ fontSize: 22, width: 28, textAlign: "center" }}>{item.icon}</span>
                <span style={{ flex: 1, fontSize: 15, color: textColor, fontWeight: active ? 600 : 400, textAlign: "left" }}>{item.label}</span>
                {/* Toggle */}
                <div style={{ width: 44, height: 26, borderRadius: 13, background: active ? leafColor : (getTheme() === "dark" ? "#444" : "#ddd"), position: "relative", transition: "background 0.2s", flexShrink: 0 }}>
                  <div style={{ position: "absolute", top: 3, left: active ? 21 : 3, width: 20, height: 20, borderRadius: "50%", background: "#fff", boxShadow: "0 1px 4px rgba(0,0,0,0.3)", transition: "left 0.2s" }} />
                </div>
              </button>
            );
          })}
        </div>

        {/* Speichern */}
        <div style={{ padding: "12px 20px 28px", borderTop: `1px solid ${getTheme() === "dark" ? "rgba(255,255,255,0.1)" : "#eee"}` }}>
          <button onClick={save}
            style={{ width: "100%", padding: "14px", background: leafColor, color: "#fff", border: "none", borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
            ✓ Speichern
          </button>
        </div>
      </div>
    </>
  );
}


export function MobileMoreMenu({ view, setView, onLogout, onEditNav }) {
  const [open, setOpen] = useState(false);
  const navBarItems = getNavBarItems();
  const moreItems = ALL_NAV_ITEMS.filter(x => !navBarItems.includes(x.v));
  const moreViews = moreItems.map(x => x.v);
  const isMoreActive = moreViews.includes(view);
  return (
    <>
      {open && (
        <div style={{ position: "fixed", inset: 0, zIndex: 999 }} onClick={() => setOpen(false)} />
      )}
      {open && (
        <div style={{ position: "fixed", bottom: 68, right: 8, background: getTheme() === "dark" ? "#1a1a1a" : "#2D5A27", borderRadius: 14, padding: "8px 0", zIndex: 1001, boxShadow: "0 8px 32px rgba(0,0,0,0.5)", minWidth: 210 }}>
          {moreItems.map(item => (
            <button key={item.v} onClick={() => { setView(item.v); setOpen(false); }}
              style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", padding: "11px 18px", background: view === item.v ? "rgba(255,255,255,0.15)" : "none", border: "none", color: "#fff", fontSize: 14, fontWeight: view === item.v ? 700 : 500, cursor: "pointer", fontFamily: "inherit", textAlign: "left" }}>
              <span style={{ fontSize: 18 }}>{item.icon}</span>{item.label}
            </button>
          ))}
          <div style={{ borderTop: "1px solid rgba(255,255,255,0.15)", margin: "6px 0" }} />
          <button onClick={() => { setOpen(false); onEditNav(); }}
            style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", padding: "11px 18px", background: "none", border: "none", color: "rgba(255,255,255,0.75)", fontSize: 14, fontWeight: 500, cursor: "pointer", fontFamily: "inherit" }}>
            <span style={{ fontSize: 18 }}>⚙️</span> Navigationsleiste anpassen
          </button>
          <div style={{ borderTop: "1px solid rgba(255,255,255,0.15)", margin: "6px 0" }} />
          <button onClick={() => { setOpen(false); onLogout(); }}
            style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", padding: "11px 18px", background: "none", border: "none", color: "rgba(255,100,100,0.9)", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
            <span style={{ fontSize: 18 }}>⏻</span> Abmelden
          </button>
        </div>
      )}
      <button onClick={() => setOpen(v => !v)}
        style={{ background: isMoreActive ? "rgba(255,255,255,0.15)" : "none", border: "none", color: isMoreActive ? "#fff" : "rgba(255,255,255,0.55)", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: 2, padding: "4px 8px", borderRadius: 8, minWidth: 44 }}>
        <span style={{ fontSize: 20 }}>☰</span>
        <span style={{ fontSize: 9, fontWeight: 600, fontFamily: "inherit" }}>Mehr</span>
      </button>
    </>
  );
}

